export default __webpack_public_path__ + "static/media/settings.f2fa10e5.svg";